import { Modal } from "BEDROCK/shared-components/modal";
import { StravaActivityList } from "strava-acquisition/components/strava-activity-list";
import styles from "./strava-activities-modal.module.css";

interface StravaActivitiesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onActivityApplied: () => void;
}

export const StravaActivitiesModal = ({
  isOpen,
  onClose,
  onActivityApplied,
}: StravaActivitiesModalProps) => {
  const handleActivityApplied = () => {
    onActivityApplied();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} showCloseButton={true} onClose={onClose}>
      <div className={styles.container}>
        <StravaActivityList
          onActivityApplied={handleActivityApplied}
          isOpen={isOpen}
        />
      </div>
    </Modal>
  );
};
